import React from 'react';
export const Urgency = () => {
  const currentDate = new Date();
  const futureDate = new Date(currentDate);
  futureDate.setDate(futureDate.getDate() + 7);
  const formatDate = date => {
    const options = {
      month: 'long',
      day: 'numeric',
      year: 'numeric'
    };
    return date.toLocaleDateString('en-US', options);
  };
  return <section className="py-16 bg-limestone-900 text-white" data-id="element-779">
      <div className="container mx-auto px-6" data-id="element-780">
        <div className="max-w-4xl mx-auto bg-gradient-to-r from-limestone-800 to-limestone-700 rounded-2xl shadow-2xl overflow-hidden" data-id="element-781">
          <div className="p-8 md:p-12" data-id="element-782">
            <div className="md:flex items-center justify-between" data-id="element-783">
              <div className="md:w-2/3 mb-8 md:mb-0" data-id="element-784">
                <h2 className="text-3xl font-bold mb-4 text-white" data-id="element-785">
                  Limited Membership Spots Available
                </h2>
                <p className="text-limestone-100 mb-6" data-id="element-786">
                  The Elite Planners Association is an invite-only community
                  with limited seats. Our next membership review closes on{' '}
                  <span className="font-bold text-white" data-id="element-787">
                    {formatDate(futureDate)}
                  </span>
                  .
                </p>
                <div className="space-y-3" data-id="element-788">
                  <div className="flex items-center" data-id="element-789">
                    <svg className="h-5 w-5 text-limestone-300 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-790">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-791"></path>
                    </svg>
                    <span className="text-limestone-100" data-id="element-792">
                      Membership by application only
                    </span>
                  </div>
                  <div className="flex items-center" data-id="element-793">
                    <svg className="h-5 w-5 text-limestone-300 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-794">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-795"></path>
                    </svg>
                    <span className="text-limestone-100" data-id="element-796">
                      Only 50 spots available for 2023
                    </span>
                  </div>
                  <div className="flex items-center" data-id="element-797">
                    <svg className="h-5 w-5 text-limestone-300 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-798">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-799"></path>
                    </svg>
                    <span className="text-limestone-100" data-id="element-800">
                      Applications reviewed in order received
                    </span>
                  </div>
                </div>
              </div>
              <div className="md:w-1/3 flex justify-center" data-id="element-801">
                <div className="text-center" data-id="element-802">
                  <div className="text-lg font-medium text-limestone-100 mb-2" data-id="element-803">
                    Application Deadline
                  </div>
                  <div className="flex space-x-2 mb-4" data-id="element-804">
                    <div className="bg-limestone-900/50 backdrop-blur-sm rounded-lg p-2 w-16" data-id="element-805">
                      <div className="text-2xl font-bold text-white" data-id="element-806">7</div>
                      <div className="text-xs text-limestone-300" data-id="element-807">Days</div>
                    </div>
                    <div className="bg-limestone-900/50 backdrop-blur-sm rounded-lg p-2 w-16" data-id="element-808">
                      <div className="text-2xl font-bold text-white" data-id="element-809">12</div>
                      <div className="text-xs text-limestone-300" data-id="element-810">Hours</div>
                    </div>
                    <div className="bg-limestone-900/50 backdrop-blur-sm rounded-lg p-2 w-16" data-id="element-811">
                      <div className="text-2xl font-bold text-white" data-id="element-812">45</div>
                      <div className="text-xs text-limestone-300" data-id="element-813">Mins</div>
                    </div>
                  </div>
                  <div className="text-xl font-bold text-white" data-id="element-814">
                    Remaining Spots: <span className="text-white" data-id="element-815">8</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};